var map = {
	"./add.svg": "58n+",
	"./comment.svg": "SdtW",
	"./edit.svg": "ql+d",
	"./eye.svg": "4wdf",
	"./finance.svg": "pTuU",
	"./form.svg": "sTIr",
	"./home.svg": "U9Ws",
	"./inventory.svg": "8X8y",
	"./order.svg": "gYtG",
	"./password.svg": "QjmH",
	"./product-comment.svg": "b5pz",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./rent.svg": "GMBf",
	"./reset.svg": "kaIC",
	"./search.svg": "Bx0U",
	"./shop.svg": "hert",
	"./sms-coupon.svg": "0Kk2",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums.svg": "J4x9",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 41